module.exports = __webpack_public_path__ + "img/user-profile.cabcbca8.png";